"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autofillBackgroundMixin = void 0;
var _styledToken = _interopRequireDefault(require("styled-token"));
/** @mixin autofillBackgroundMixin */
/**
 * Adds autofill styling to a component.
 *
 * @example
 * import { autofillBackgroundMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     &:-webkit-autofill {
 *          ${autofillBackgroundMixin};
 *      }
 * `;
 *
 * <Component>My component with autofill atyling</Component>
 *
 * @method
 * @param props {object}
 * @param props.theme {object} The styled-components theme.
 * @return {CSSObject}
 */
var autofillBackgroundMixin = function autofillBackgroundMixin(props) {
  return "\n    box-shadow: 0 0 0 1000px " + ((0, _styledToken.default)('Input.backgroundColorAutofill')(props) || '') + " inset;\n";
};
exports.autofillBackgroundMixin = autofillBackgroundMixin;